// app/frontend/controllers/hello_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static hasLogged = false;

  connect() {
    // Only log once globally (not per instance) to avoid spam during Turbo navigation
    if (!this.constructor.hasLogged) {
      this.constructor.hasLogged = true;
    }
    // Always update the element text (this is fine to do on each connect)
    this.element.textContent = "Stimulus is connected!";
  }
}

